var exports = {
  "J5": "Octicon_0__U0klMM",
  "DR": "Box_0__u87wha",
  "Fq": "TextInput_0__oISrjf",
  "wy": "Box_1__Hl9iDR",
  "M4": "TextInput_1__ZsFa4N",
  "a3": "Button_0__5ZeDnK",
  "hJ": "Overlay__wpUIQM",
};

module.exports = exports;
